<template>
  <div id="container">
    <van-divider content-position="left">押金</van-divider>
    <van-cell-group>
      <van-cell title="订单号" :value='model.code'/>
      <van-cell title="创建时间" :value='model.create_time'/>
      <van-cell title="创建人" :value='model.ent_employee_name'/>
      <van-cell title="节点" :value='model.wor_node_name'/>
      <van-cell v-if="model.datas!==undefined" title="价格" :value="model.datas.price + '元'"/>
      <van-cell v-if="model.datas!==undefined" title="备注" :value="model.datas.remark"/>
    </van-cell-group>

    <div class="submit-block" />

    <div v-if="model.wor_node_id==='1828a1f8a98d11ec9475afeb8f0a8271'&&model.is_check===0" style="position:fixed;bottom:0;width:100%">
      <van-button block type="primary" @click="() => { this.displayReceipts = true }">您有1笔款项待支付</van-button>
    </div>

    <van-popup v-model="displayReceipts">
      <div class="padding-10" v-for="receipt in receipts" :key="receipt.id">
        <van-button block type="primary" @click="pay(receipt.id)">支付收款单：{{receipt.datas.price}}元</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Api from '@/utils/api'
import wx from 'weixin-js-sdk'
export default {
  created () {
    Api.post('wei.user/jsapi', {url: window.location.href}, res => {
      let data = res.data
      wx.config({
        debug: false,
        appId: data.appid,
        timestamp: data.timestamp,
        nonceStr: data.noncestr,
        signature: data.signature,
        jsApiList: ['chooseWXPay']
      })
    })
    this.reload()
  },
  data () {
    return {
      model: {},
      receipts: [],

      displayReceipts: false
    }
  },
  methods: {
    pay (id) {
      this.displayReceipts = false
      var that = this
      wx.ready(function () {
        Api.post('pay.weixin/index', {wor_request_id: id}, res => {
          var payWeixin = res.data
          wx.chooseWXPay({
            timestamp: payWeixin.timestamp.toString(),
            nonceStr: payWeixin.noncestr,
            package: payWeixin.package,
            signType: 'MD5',
            paySign: payWeixin.sign,
            success: function (res) {
              // 核对订单支付状态
              Api.post('pay.weixin/model', {id: payWeixin.id}, res => {
                if (res.is_check === 1) {
                  that.$toast.success('支付成功')
                } else {
                  that.$toast.fail('支付异常')
                }
                that.reload()
              })
            },
            cancel: function (res) {
              console.log(res)
              that.$toast.fail('取消支付')
            },
            fail: function (res) {
              console.log(res)
              that.$toast.fail('支付失败')
            }
          })
        })
      })
    },
    reload () {
      Api.post('wor.request/model', {id: this.$route.query.id}, res => {
        this.model = res.data
        let ids = []
        res.data.wor_datarows.forEach(worDatarow => {
          if (worDatarow.wor_table_id !== '65b410ced7c411ebb59b797c008dc329') return true
          ids.push(worDatarow.datas.sal_product_id)
        })
        // 获取应收单数据集
        Api.post('wor.request/models', {parent_id: res.data.id, is_check: 0, page: 1, limit: -1, datas: 1}, res => { this.receipts = res.data })
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/sal/pledge/Model.vue